export const Breakpoints = {
  XS: 0,
  SM: 576,
  MD: 768,
  LG: 992,
  XL: 1200,
  XXL: 1400,
  XXXL: 1680,
  FIXED: 1440,
} as const;

export const getCurrentBreakpoint = (windowWidth: number) => {
  if (windowWidth < Breakpoints.SM) {
    return "XS";
  } else if (windowWidth < Breakpoints.MD) {
    return "SM";
  } else if (windowWidth < Breakpoints.LG) {
    return "MD";
  } else if (windowWidth < Breakpoints.XL) {
    return "LG";
  } else if (windowWidth < Breakpoints.XXL) {
    return "XL";
  } else if (windowWidth < Breakpoints.XXXL) {
    return "XXL";
  } else {
    return "XXXL";
  }
};
